import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"; 
import { UserProfession, UserProfessionClient } from "../../../web-api-client";
import { UserProfessionEditComponent } from "./userProfession-edit/userProfession-edit.component";
import { UnSuccessModalComponent } from "../../../modals/failed-modal/failed-modal.component";
import { SuccessModalComponent } from "../../../modals/success-modal/success-modal.component";
import { ConfirmModalComponent } from "../../../modals/confirm-modal/confirm-modal.component";
import { UserProfessionCreationComponent } from "./userProfession-creation/userProfession-creation.component";


@Component({
  selector: 'app-userProfession',
  templateUrl: './userProfession.component.html',
  styleUrls: ['./userProfession.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class UserProfessionComponent implements OnInit {

  public isLoaded: boolean = false;
  selectedObject: UserProfession;
  public allObjects: UserProfession[];

  // Assuming you already have a property for all the objects
  public searchQuery: string = '';
  filteredObjects: UserProfession[] = [];




  constructor(private readonly changeDetectionRef:ChangeDetectorRef, private readonly modalService: NgbModal,public client:UserProfessionClient){

  }

  ngOnInit(): void {

    this.loadData();

  }


  public filterObjects() {
    if (this.searchQuery) {
      this.filteredObjects = this.allObjects.filter(object =>
        object.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        object.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredObjects = this.allObjects;
    }
  }

  public loadData() {
        this.client.getList().subscribe((allObjects: UserProfession[]) => {
          this.allObjects = allObjects;
          this.filteredObjects = allObjects;
            this.isLoaded = true;
            this.changeDetectionRef.detectChanges();
        });
    }

  public onSelected(object: UserProfession){
   if (this.isSelected(object)){
    this.selectedObject = null;
  }
  else{

     this.selectedObject = object;
  }
 }

  public isSelected(object: UserProfession):boolean{
    return this.selectedObject == object;
 }

public onCreation():void{
  let modalRef = this.modalService.open(UserProfessionCreationComponent, {});

  modalRef.componentInstance.onClose.subscribe(r => {

    this.loadData();

  });

}


public onDelete(): void {


    let modalRef = this.modalService.open(ConfirmModalComponent);

    modalRef.componentInstance.onClose.subscribe(result => {
      if (result === true) {

        this.client.remove(this.selectedObject.idUserProfession).subscribe(r => {
          this.allObjects = this.allObjects.filter(d => d.idUserProfession != this.selectedObject.idUserProfession);
          this.filteredObjects = this.allObjects.slice(0);
          this.changeDetectionRef.detectChanges();
        })
      }
      else {
        this.modalService.open(UnSuccessModalComponent);
      }
    });


  }

  public onEdit(): void {

    let modalRef = this.modalService.open(UserProfessionEditComponent);
    modalRef.componentInstance.editObject = this.selectedObject;

    modalRef.componentInstance.onClose.subscribe(r => {

      this.loadData();

    });

    }

}
